/**
 * Part — frontend mirror of the NestJS Part model (Phase 4b).
 *
 * Part is a *catalog* row that describes a specific reference
 * (e.g. "Parker hydraulic filter HP, 10µm, ref 925034") associated
 * with a parent PartType. Each Part can be stocked in multiple
 * StockLot rows across different vessels.
 *
 * Catalog scope (same hybrid pattern as PartType):
 *   - ownerCompanyId === null  → global ISI catalog
 *   - ownerCompanyId === '...' → company-scoped custom part
 *
 * `unit` overrides the parent PartType.defaultUnit. If null, the
 * UI falls back to the parent type's defaultUnit.
 *
 * `minStockGlobal` / `maxStockGlobal` are company-wide thresholds
 * inherited by all StockLot rows of this Part. Per-lot
 * minStockOverride / maxStockOverride can refine these on
 * vessel-by-vessel basis (Phase 4c).
 */

export interface Part {
  id: string;
  code: string;
  name: string;
  partTypeId: string;
  manufacturer: string | null;
  manufacturerPartNumber: string | null;
  /** null = use parent PartType.defaultUnit. */
  unit: string | null;
  minStockGlobal: number | null;
  maxStockGlobal: number | null;
  ownerCompanyId: string | null;
  notes: string | null;
  isActive: boolean;
  /** L2 — MinIO/S3 key for the part photo, or null. */
  photoKey: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

/** True when this part belongs to the global ISI catalog. */
export function isGlobalPart(p: Part): boolean {
  return p.ownerCompanyId === null;
}
